// eslint-disable-next-line
export const SITE_SETTINGS_FETCH = 'SITE_SETTINGS_FETCH';
